import {filters} from "@atttomyx/shared-constants";

export const USER_FILTERS = {
    firstName: {
        label: "first name",
        type: filters.TYPE_STRING,
    },
    lastName: {
        label: "last name",
        type: filters.TYPE_STRING,
    },
    role: {
        type: filters.TYPE_BOOLEAN,
        getter: (item) => item.roles.admin,
        formatter: (value) => value === "true" ? "Admin" : "User",
    },
};
